export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-review.vue?vue&type=template&id=b7294ef8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-review.vue?vue&type=template&id=b7294ef8&
// module id = 1401
// module chunks = 0